module.exports = __webpack_public_path__ + "img/0c7d267.png";